const matches = (pattern , name) => {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern === name
  } else if (Object.prototype.toString.call(pattern) === '[object RegExp]') {
    return pattern.test(name)
  }
  return false
}

const check = (cache  , filter) => {
  for (const key in cache) {
    if (cache[key] && !filter(key)) {
      remove(cache, key)
    }
  }
}

const remove = (cache , key , current)=>{
  //console.log( `remove `,key , cache[key])
  const cached = cache[key]
  if (cached) {
    cached.componentInstance.$destroy()
  }
  // Reflect.deleteProperty(cache , key)
  cache[key] = null
}


const keepAlive = {
  name: 'KeepAlive',
  abstract: true,
  props: {
    include:{ type: Array },
    exclude:{ type: Array }
  },
  watch: {
    include (val) {
      check(this.cache, name => matches(val, name))
    },
    exclude (val) {
      check(this.cache, name => !matches(val, name))
    }
  },
  created() {
    this.cache = {}
    this.$keepAlive = this
  },

  methods:{
    update(name){
      const { cache } = this 
      if(name == undefined){
        for (let key in cache) {
          this.refresh(key)
        }
      }else{
        let arr = Array.isArray(name) ? name : [name]
        arr.forEach( i => {
          let key = this.$router.getRouteByCode(i)
          this.refresh(key)
        })
      }

    },

    refresh(key){
      const { cache } = this 
      if (cache[key]) {
        const instance = cache[key].componentInstance
        if( instance.$update ){
          instance.$update()
        }
      }
    }
  },
  render() {
    const vnode = this.$slots.default ? this.$slots.default[0] : null

    const name = this.$route.name

    // 不在特例内 则不使用缓存
    if (name && (
      (this.include && !matches(this.include, name)) ||
      (this.exclude && matches(this.exclude, name))
    )) {
      //触发
      return vnode
    }

    const { cache } = this 

    if (cache[name]) {
      vnode.componentInstance = cache[name].componentInstance
    } else {
      cache[name] = vnode
    }

    vnode.data.keepAlive = true

    return vnode
  },

  destroyed () {
    for (const key in this.cache) {
      remove(this.cache, key)
    }
  }
}

const install = (Vue) => {
  Object.defineProperty(Vue.prototype, '$keepAlive', {
    get: function get () { return this._keepAlive },
    set: function set ( i ) { Vue.prototype._keepAlive = i }
  })

  Vue.component(keepAlive.name, keepAlive);
}

export default {
  install
}